import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent {
  @Input() squareMode = false;

  @Input()
  set name(value: string) {
    value = value?.trim();

    if (value) {
      const words = value.split(' ');
      if (words) {
        const initials = words[0]?.charAt(0) + (words[1]?.charAt(0) || '');
        this.letter = initials.toUpperCase();
      } else {
        this.letter = '';
      }
      this.i = this.simpleHash(value);
    }
  }

  @Input() src?: string;
  @Input() size?: string;

  letter?: string;
  i?: number;

  constructor() { }

  simpleHash(str: string) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = hash + char;
      hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([hash])[0] % 16 + 1;
  }

  get parsedSize(): number {
    const fallback = 16;
  
    if (!this.size) return fallback;
  
    // Remove "px", convert to number
    const numeric = parseFloat(this.size.toString());
  
    // If it's a valid number, scale it
    return Number.isFinite(numeric) ? numeric / 2.1 : fallback;
  }
}
